import { List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { MenuItem, RuleFactoryType } from "@repo/server-api/types";
import { useUserRoles, RuleComponent  } from "@repo/shared/components";
import { useTranslation } from "next-i18next";
import React, { useState } from "react";
import { Link } from "react-router-dom";


interface SidebarItemProps {
	item: MenuItem;
	ruleFactory: RuleFactoryType;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ item, ruleFactory }) => {
	const [open, setOpen] = useState(false);
	const { t } = useTranslation();

	const roles = useUserRoles();

	const handleClick = () => {
		if (item.subItems) {
			setOpen(!open);
		}
	};

	// const IconComponent = item.icon;

	const factorize = (label: string) => {
		return label.split(" ").join("-").toLocaleLowerCase();
	};

	return (
		<>
			<ListItemButton
				onClick={handleClick}
				component={item.path ? Link : "div"}
				to={item.path || "#"}>
				<ListItemText
					primary={
						<Typography style={{ color: "#A0A0A0" }}>
							{t(factorize(item.label), { ns: "menu" }).toLocaleUpperCase()}
						</Typography>
					}
				/>
			</ListItemButton>

			{item.subItems && (
				<List component="div" disablePadding>
					{item.subItems.map((subItem) => (
						<RuleComponent
							rule={() => ruleFactory.allowedMenuItem(subItem.key, roles.roles)}
							key={subItem.label}>
							<ListItemButton key={subItem.label} component={Link} to={subItem.path!}>
								{subItem.icon && (
									<ListItemIcon>{<subItem.icon style={{ fontSize: 40 }} />}</ListItemIcon>
								)}
								<ListItemText
									primary={
										<Typography>
											{t(factorize(item.label) + "." + factorize(subItem.label), {
												ns: "menu",
											}).toLocaleUpperCase()}
										</Typography>
									}
								/>
							</ListItemButton>
						</RuleComponent>
					))}
				</List>
			)}
		</>
	);
};

export default SidebarItem;
